import { Box, CircularProgress, Typography } from '@mui/material'
import { PropsWithChildren } from 'react'

export default function SplashScreen({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant='h6'>{children || 'Please wait...'}</Typography>
    </Box>
  )
}
